import city from "@svg-icons/city.component.svg";
import country from "@svg-icons/country.component.svg";
import highway from "@svg-icons/highway.component.svg";
import trailer from "@svg-icons/trailer.component.svg";
import car from "@svg-icons/car.component.svg";
import mc from "@svg-icons/mc.component.svg";
import truck from "@svg-icons/truck.component.svg";
import bus from "@svg-icons/bus.component.svg";
import roadWorker from "@svg-icons/road-worker.component.svg";
import sandclock from "@svg-icons/sandclock.component.svg";

export const data = {
  vehicles: [
    {
      label: "Personbil",
      value: "car",
      default: true,
      icon: car
    },
    {
      label: "Motorcykel",
      value: "mc",
      default: false,
      icon: mc
    },
    {
      label: "Lastbil",
      value: "truck",
      default: false,
      icon: truck
    },
    {
      label: "Bus",
      value: "bus",
      default: false,
      icon: bus
    },
    {
      label: "Bus 100",
      value: "bus100",
      default: false,
      icon: bus
    }
  ],
  roadTypes: [
    {
      label: "Byvej",
      value: "city",
      default: false,
      hint: "50 km/t",
      icon: city,
      speedLimits: {
        default: 50,
        min: 30,
        max: 80,
        available: [30, 40, 50, 60, 70]
      }
    },
    {
      label: "Land- / Motortrafikvej",
      value: "country",
      default: true,
      hint: "80 km/t",
      icon: country,
      speedLimits: {
        default: 80,
        min: 40,
        max: 90,
        available: [40, 50, 60, 70, 80, 90]
      }
    },
    {
      label: "Motorvej",
      value: "highway110",
      default: false,
      hint: "110 km/t",
      icon: highway,
      speedLimits: {
        default: 110,
        min: 40,
        max: 110,
        available: [40, 50, 60, 70, 80, 90, 100, 110]
      }
    },
    {
      label: "Motorvej",
      value: "highway130",
      default: false,
      hint: "130 km/t",
      icon: highway,
      speedLimits: {
        default: 130,
        min: 40,
        max: 130,
        available: [40, 50, 60, 70, 80, 90, 100, 110, 130]
      }
    }
  ],
  conditions: [
    {
      label: "Vejarbejde",
      value: "roadwork",
      default: false,
      icon: roadWorker,
      multiplier: 2
    },
    /* {
      "label": "Spirituskørsel",
      "value": "alcohol",
      "default": false,
	  "icon": wineGlass,
    }, */
    {
      label: "Prøveperiode",
      value: "probation",
      default: false,
      icon: sandclock
    },
    {
      label: "Almindelig anhænger",
      value: "trailer",
      default: false,
      icon: trailer
    },
    {
      label: "Tempo 100-godkendt anhænger",
      value: "trailer-tempo100",
      default: false,
      icon: trailer
    }
  ],
  speedLimits: [
    {
      value: 30,
      label: "30 km/t"
    },
    {
      value: 40,
      label: "40 km/t"
    },
    {
      value: 50,
      label: "50 km/t"
    },
    {
      value: 60,
      label: "60 km/t"
    },
    {
      value: 70,
      label: "70 km/t"
    },
    {
      value: 80,
      label: "80 km/t"
    },
    {
      value: 90,
      label: "90 km/t"
    },
    {
      value: 100,
      label: "100 km/t"
    },
    {
      value: 110,
      label: "110 km/t"
    },
    {
      value: 130,
      label: "130 km/t"
    }
  ],
  vehicleSpeedLimits: {
    car: {
      city: {
        min: 30,
        max: 70,
        default: 50
      },
      country: {
        min: 40,
        max: 100,
        default: 80,
        trailer: {
          min: 40,
          max: 80,
          default: 80
        },
        "trailer-tempo100": {
          min: 50,
          max: 80,
          default: 80
        }
      },
      highway130: {
        min: 50,
        max: 130,
        default: 130,
        trailer: {
          min: 50,
          max: 80,
          default: 80
        },
        "trailer-tempo100": {
          min: 50,
          max: 100,
          default: 100
        }
      },
      highway110: {
        min: 50,
        max: 110,
        default: 110,
        trailer: {
          min: 50,
          max: 80,
          default: 80
        },
        "trailer-tempo100": {
          min: 50,
          max: 100,
          default: 100
        }
      }
    },
    mc: {
      city: {
        min: 30,
        max: 70,
        default: 50
      },
      country: {
        min: 40,
        max: 100,
        default: 80,
        trailer: {
          min: 40,
          max: 80,
          default: 80
        }
      },
      highway130: {
        min: 50,
        max: 130,
        default: 130,
        trailer: {
          min: 50,
          max: 80,
          default: 80
        }
      },
      highway110: {
        min: 50,
        max: 110,
        default: 110,
        trailer: {
          min: 50,
          max: 80,
          default: 80
        }
      }
    },
    truck: {
      city: {
        min: 30,
        max: 70,
        default: 50
      },
      country: {
        min: 40,
        max: 80,
        default: 80
      },
      highway130: {
        min: 50,
        max: 80,
        default: 80
      },
      highway110: {
        min: 50,
        max: 80,
        default: 80
      }
    },
    bus: {
      city: {
        min: 30,
        max: 70,
        default: 50
      },
      country: {
        min: 40,
        max: 80,
        default: 80
      },
      highway130: {
        min: 50,
        max: 80,
        default: 80
      }
    },
    bus100: {
      city: {
        min: 30,
        max: 70,
        default: 50
      },
      country: {
        min: 40,
        max: 80,
        default: 80
      },
      highway130: {
        min: 50,
        max: 80,
        default: 80,
        trailer: {
          min: 50,
          max: 80,
          default: 60
        }
      },
      highway110: {
        min: 50,
        max: 80,
        default: 80,
        trailer: {
          min: 50,
          max: 80,
          default: 60
        }
      }
    }
  },
  fineRates: [
    {
      percentage: 0,
      rate1: 1200,
      rate2: 1200,
      rate3: 1800
    },
    {
      percentage: 20,
      rate1: 1800,
      rate2: 1800,
      rate3: 1800
    },
    {
      percentage: 30,
      rate1: 1800,
      rate2: 2400,
      rate3: 2400
    },
    {
      percentage: 40,
      rate1: 2400,
      rate2: 3000,
      rate3: 3000
    },
    {
      percentage: 50,
      rate1: 2400,
      rate2: 3600,
      rate3: 3600
    },
    {
      percentage: 60,
      rate1: 3000,
      rate2: 4200,
      rate3: 4200
    },
    {
      percentage: 70,
      rate1: 3600,
      rate2: 5400,
      rate3: 5400
    },
    {
      percentage: 80,
      rate1: 4200,
      rate2: 6000,
      rate3: 6000
    },
    {
      percentage: 90,
      rate1: 5400,
      rate2: 7800,
      rate3: 7800
    },
    {
      percentage: 100,
      rate1: 6000,
      rate2: 9000,
      rate3: 9000
    }
  ],
  defaults: {
    speed: 40,
    roadType: "country",
    speedLimit: 80,
    roadwork: false,
    vehicle: "car"
  },
  vehicleTrailerCompatibility: {
    car: {
      canUseTrailer: true,
      canUseTempo100Trailer: true
    },
    mc: {
      canUseTrailer: true,
      canUseTempo100Trailer: false
    },
    truck: {
      canUseTrailer: true,
      canUseTempo100Trailer: false
    },
    bus: {
      canUseTrailer: true,
      canUseTempo100Trailer: false
    },
    bus100: {
      canUseTrailer: true,
      canUseTempo100Trailer: true
    }
  },
  rateDescriptions: {
    rate1: "Under/= 100km og mc eller car og ingen trailer",
    rate2: "Over/= 100km og mc eller car",
    rate3:
      "Bus eller truck eller, mc eller car og trailer eller trailer-tempo100"
  },
  texts: {
    results: {
      tabs: [
        {
          url: "#",
          label: "1 klip",
          text:
            "Hvis du får et enkelt klip i kørekortet, betyder det i første omgang, at forseelsen bliver registreret i Færdselsstyrelsens kørekortregister. Et klip fungerer som en form for advarsel og viser, at du har overtrådt færdselsloven på en måde, der anses for alvorlig – for eksempel ved at bruge håndholdt mobil under kørsel, køre for hurtigt eller undlade at bruge sele."
        },
        {
          url: "#",
          label: "6 mdr. frakendelse",
          text:
            "Ved alvorligere overtrædelser kan dit kørekort blive frakendt i 6 måneder. Dette sker typisk ved gentagne klip eller særligt grove færdselsforseelser som spirituskørsel, kørsel under påvirkning af euforiserende stoffer, eller meget høje hastighedsovertrædelser. Under frakendelsesperioden må du ikke køre bil, og du skal aflevere dit kørekort til politiet."
        },
        {
          url: "#",
          label: "Ny køreprøve",
          text:
            "I de mest alvorlige tilfælde kan du blive pålagt at tage en ny køreprøve for at få dit kørekort tilbage. Dette kan ske ved særligt grove eller gentagne overtrædelser, hvor myndighederne vurderer, at du skal dokumentere dine kørefærdigheder på ny. Den nye køreprøve omfatter både teoriprøve og praktisk køreprøve, ligesom når du første gang tog kørekort."
        }
      ]
    }
  },
  resultCard: {
    ui: {
      headerTexts: {
        noFine: "Ingen bøde",
        withFine: "Din bøde lige nu:"
      },
      buttonTexts: {
        close: "Luk",
        expand: "Yderligere konsekvenser"
      },
      currency: "kr",
      unconditionalDisqualification: "Ubetinget frakendelse",
      probationPeriodTitle: "Hvis du har haft kørekort i mindre end 3 år:",
      probationPeriodText: [
        "Du får også kørselsforbud.",
        "Du skal også betale 500 kr. til Offerfonden."
      ],
      unconditionalDisqualificationTitle:
        "Hvis du har haft kørekort i 3 år eller mere:",
      unconditionalDisqualificationText: [
        "Du får også en betinget frakendelse af dit kørekort.",
        "Du skal også betale 500 kr. til Offerfonden."
      ],
      ubetTitle: "Ubetinget frakendelse",
      ubetText: [
        "Du får en ubetinget frakendelse af dit kørekort.",
        "Køretøjet kan blive konfiskeret, og du risikerer fængselsstraf, da hastigheden defineres som vanvidskørsel.",
        "Du får også en stor bøde, der afhænger af de konkrete omstændigheder, og du skal betale 500 kr. til Offerfonden."
      ],
      truckInfo: [
        "En lastbil må ikke kunne køre mere end 90 km/t:",
        "Du vil blive straffet, hvis der er foretaget indgreb i fartbegrænseren."
      ],
      busInfo: [
        "En bus må ikke kunne køre mere end 100 km/t.",
        "Du vil blive straffet, hvis der er foretaget indgreb i fartbegrænseren."
      ],
      busTempo100Info: [
        "En bus Tempo 100 må ikke kunne køre mere end 100 km/t.",
        "Du vil blive straffet, hvis der er foretaget indgreb i fartbegrænseren."
      ]
    },
    mapping: {
      roadTypes: {
        city: "Byvej",
        country: "Landvej",
        highway130: "Motorvej 130",
        highway110: "Motorvej 110"
      },
      vehicles: {
        car: "Personbil",
        mc: "Motorcykel",
        truck: "Lastbil",
        bus: "Bus",
        bus100: "Bus 100"
      },
      conditions: {
        roadwork: "Vejarbejde",
        probation: "Prøveperiode",
        trailer: "Almindelig anhænger",
        "trailer-tempo100": "Tempo 100-godkendt anhænger",
        alcohol: "Spirittutkjørsel"
      }
    },
    fallbackText: "157 km/t + Bysone + Personbil + Spirittutkjørsel",
    rules: {
      speedLimits: {
        maxSpeed: 300,
        vehicleSpecific: {
          truck: {
            maxSpeed: 90,
            displayText: "truck"
          },
          bus: {
            maxSpeed: 100,
            displayText: "bus"
          },
          bus100: {
            maxSpeed: 100,
            displayText: "bus-tempo100"
          }
        }
      },
      isUbet: {
        speedThreshold: 200,
        percentageOverDefault: 40,
        conditions: {
          car: {
            noTrailer: {
              percentageOver: 101,
              minSpeed: 101
            },
            withTrailer: {
              percentageOver: 100,
              minSpeed: 101
            }
          },
          mc: {
            noTrailer: {
              percentageOver: 101,
              minSpeed: 101
            },
            withTrailer: {
              percentageOver: 100,
              minSpeed: 101
            }
          },
          bus: {
            percentageOver: 101,
            minSpeed: 101
          },
          bus100: {
            percentageOver: 101,
            minSpeed: 101
          },
          truck: {
            percentageOver: 101,
            minSpeed: 101
          }
        }
      },
      displayTexts: {
        betkor: {
          conditions: [
            {
              description: "Over 40% and roadwork",
              percentageOver: 40,
              roadwork: true
            },
            {
              description: "Over 40% for bus, truck, or vehicles with trailer",
              percentageOver: 40,
              vehicles: ["bus", "truck"],
              withTrailer: true
            },
            {
              description:
                "Over 60% for car/mc without trailer OR speed >= 160",
              percentageOver: 60,
              vehicles: ["car", "mc"],
              noTrailer: true,
              orSpeedThreshold: 160
            }
          ]
        },
        klip: {
          description: "Over 30% for any vehicle",
          percentageOver: 0 // Change in case of showing the result card yellow background again, it was 30% in the old version
        }
      },
      fineCalculation: {
        highSpeedPenalty: {
          threshold: 140,
          baseAmount: 1200,
          incrementPer10km: 600
        },
        roadworkMultiplier: 2,
        highSpeedOver30Percent: {
          city: true,
          countryMaxSpeed: 90
        }
      }
    }
  }
};
